export default __webpack_public_path__ + "static/media/blueberry-coconut-banana-bread.9e42e937.png";